<template>
  <div class="header_navigation_bar">
    <navi-step class="step1" stepClick="stepForward1">STEP1</navi-step>
    <navi-step class="step2" stepClick="stepForward2">STEP2</navi-step>
    <navi-step class="step3" stepClick="stepBackward">STEP3</navi-step>
  </div>
</template>

<script>
import NaviStep from "./NaviStep.vue"
export default {
  components: {
    NaviStep
  },
  props: {
    naviName: String
  },
  methods: {
    stepForward1: function() {
      alert("1");
    },
    stepForward2: function() {
      alert("3");
    },
    stepBackward: function() {
      this.$emit("stepBackward")
    }
  }
};
</script>

<style scoped>
.header_navigation_bar {
  display: flex;
  margin: 0 auto;
  align-content: center;
}
.step1,
.step2,
.step3 {
  width: 30vw;
}
.step1 {
  background-color: black;
  color: white;
  border-color: green;
}
.step2 {
  background-color: black;
  color: white;
}
.step3 {
  background-color: black;
  color: white;
}
</style>
